import { graphql } from 'gatsby';
import {
  StyledSubheadlineWrapper,
  StyledSubHeadline,
  StyledSubHeadlineLink,
  StyledImage,
  StyledLinksWrapper,
} from './ColumnSection.styles';
import ColumnSectionLink from './ColumnSectionLink';
import useLinkProps from '@/components/Link/hooks/useLinkProps';

const SECTION_IMAGE_WIDTH = 272;
const SECTION_IMAGE_HEIGHT = 142;

interface ColumnSectionProps extends Queries.HEADER_MENU_ITEM_COLUMN_SECTIONFragment {
  onLinkClick: () => void;
}

const ColumnSection = ({ elements, onLinkClick }: ColumnSectionProps) => {
  const { subheadline, subheadline_link, links, image } = elements;
  const hasSubheadlineLink = !!subheadline_link?.value;
  const hasSubheadline = !!subheadline?.value;
  const subHeadlineLinkProps = useLinkProps({
    action: subheadline_link?.value?.linkElements.action.value,
    target: subheadline_link?.value?.linkElements.target?.value,
    event: subheadline_link?.value?.linkElements.event?.value,
  });
  const hasSubheadlineSection = hasSubheadlineLink || hasSubheadline;
  const imageValue = image?.value && {
    ...image.value,
    description: image.value.description ?? undefined,
    width: image.value.width ?? SECTION_IMAGE_WIDTH,
    height: image.value.height ?? SECTION_IMAGE_HEIGHT,
  };

  return (
    <div>
      {hasSubheadlineSection && (
        <StyledSubheadlineWrapper>
          {hasSubheadlineLink ? (
            <StyledSubHeadlineLink {...{ ...subHeadlineLinkProps.linkProps, variant: null }}>
              {subheadline_link.value.linkElements.text.value}
              {subHeadlineLinkProps.linkChildren}
            </StyledSubHeadlineLink>
          ) : (
            hasSubheadline && <StyledSubHeadline>{subheadline.value}</StyledSubHeadline>
          )}
        </StyledSubheadlineWrapper>
      )}
      {imageValue && (
        <StyledImage
          image={{
            ...imageValue,
            image_id: imageValue.url,
          }}
          width={imageValue.width}
          height={imageValue.height}
          alt={imageValue.description}
          layout="fullWidth"
        />
      )}
      <StyledLinksWrapper hasSubheadline={hasSubheadline}>
        {links.value.map((link) => (
          <ColumnSectionLink {...link} key={link.system.id} onLinkClick={onLinkClick} />
        ))}
      </StyledLinksWrapper>
    </div>
  );
};

export default ColumnSection;

export const fragment = graphql`
  fragment HEADER_MENU_ITEM_COLUMN_SECTION on kontent_item_header_menu_item_column_section {
    __typename
    system {
      id
    }
    elements {
      subheadline {
        value
      }
      subheadline_link {
        value {
          ...LINK
        }
      }
      links {
        value {
          ...HEADER_COLUMN_SECTION_LINK
        }
      }
      image {
        value {
          description
          url
          width
          height
        }
      }
    }
  }
`;
